/**
 * Import from node_modules
 */
// import 'bootstrap/js/src/scrollspy';

/**
 * Import site scripts
 */
import Animatios from './site/animations';
import Menu from './site/menu';
import ScrollTo from './site/scrollTo';
import Header from './site/header';
import SubscribeWidget from './site/subscribeWidget';

/**
 * Init site scripts
 */
jQuery(function() {
	Animatios.init();
	Menu.init();
	ScrollTo.init();
	Header.init();
	SubscribeWidget.init();
});
